(function () {
    'use strict';
    angular.module('servicesModule').controller('WhatsNewFolderModalController', controller);
    controller.$inject = ['$scope', '$http', '$uibModal', '$uibModalInstance', 'model', '$sce'];

    function controller($scope, $http, $uibModal, $modalInstance, model, $sce) {
        var vm = this;
        vm.globalResources = angular.copy(globalResources);
        vm.data = model;
        vm.close = close;
        vm.showDropdown = false;
        vm.listPeriod = [
            { name: vm.globalResources.Today, value: 0 },
            { name: vm.globalResources.LastWeek, value: 1 },
            { name: vm.globalResources.LastMonth, value: 2 },
            { name: vm.globalResources.Last3Months, value: 3 },
        ];
        vm.selectedPeriod = vm.listPeriod[parseInt(HandbookConfiguration.WhatsNewPeriodFolder)];
        vm.selectPeriod = selectPeriod;
        vm.whatsNewDocuments = vm.data.WhatsNewDocuments;
        vm.showWhatsNewDocumentsInSubChapters = vm.data.showWhatsNewDocumentsInSubChapters;
        vm.showWhatsNewDocumentsRecursive = showWhatsNewDocumentsRecursive;
        initialize();
        function initialize() {
            setPeriod(parseInt(vm.data.selectedOption))
        }

        function setPeriod(optionNumber) {
            const period = vm.listPeriod.filter(function (period) {
                return period.value == optionNumber;
            })
            if (period && period.length) {
                vm.selectedPeriod = period[0];
            }
        }

        function selectPeriod(period) {
            vm.data.changeSelectedOptionInMobileView(period);
            setPeriod(period.value); 
            getWhatsNewForFolder();
        }

        function showWhatsNewDocumentsRecursive() {
            getWhatsNewForFolder();
        }

        function getWhatsNewForFolder() {
            $http.get(handbookRequests.GetRecentlyApprovedDocumentsForFolder, { params: { 'folderId': vm.data.folderData.id, 'includeSubFolder': vm.showWhatsNewDocumentsInSubChapters, 'periodOption': vm.selectedPeriod.value } })
                .success(function (data, status, headers, config) {
                    vm.whatsNewDocuments  = data;
                });
        };

        function close() {
            $modalInstance.close(true);
        };
    };
})();